module.exports = __webpack_public_path__ + "img/pl.5eed0eff.svg";